import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DROPDOWN_CLOSED } from './events';

// Should be the only child of Dropdown.Menu. Children should be MenuItem or ParentItem. This is
// what allows for nested menus - not necessary to use if not nested. Can also be the only child
// of ParentItem components for deeply nested menus.
//
// NOTE: react-bootstrap really does require its own Menu component as an immediate child, not some
//       wrapping component, so this must be used inside Dropdown.Menu rather than in place of it.
export default function DropdownMenuItems({ children, onSelect }) {
  const [openItemIndex, setOpenItemIndex] = useState();

  window.addEventListener(DROPDOWN_CLOSED, () => setOpenItemIndex(undefined));

  return (
    <React.Fragment>
      {React.Children.map(children, (child, i) => {
        return React.cloneElement(child, {
          open: i === openItemIndex,
          onMouseEnter: () => setOpenItemIndex(i),
          // Provided by bootstrap - must pass along for the dropdown to close on click
          onSelect,
        });
      })}
    </React.Fragment>
  );
}

DropdownMenuItems.propTypes = {
  children: PropTypes.node.isRequired,
  onSelect: PropTypes.func,
};
